const PRODUCTION_API_HOST = 'ovatu.com'

export function resolveMarketingOrigin(apiUrl: string): 'https://ovatu.com' | 'https://ovatu.dev' {
  try {
    return new URL(apiUrl).hostname === PRODUCTION_API_HOST
      ? 'https://ovatu.com'
      : 'https://ovatu.dev'
  } catch {
    return 'https://ovatu.dev'
  }
}

// TODO: remove once marketing-nuxt ships /login/recent/capture to ovatu.com (it 404s there until then).
export function isRecentLocationCaptureEnabled(apiUrl: string): boolean {
  return resolveMarketingOrigin(apiUrl) !== 'https://ovatu.com'
}
